import { apiRequest } from "./apiClient";
export const getAISummary = async (payload) => {
  return await apiRequest({ method: "POST", endpoint: "/ai-summary", body: payload });
};